module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/readable-stream/writable-browser.js
// module id = ../../../../readable-stream/writable-browser.js
// module chunks = 5